// utils/formatDate.js
export function formatDbDate(dateString) {
    try {
        if (!dateString) return "—";

        const date = new Date(dateString);
        if (isNaN(date)) return "—";

        const options = {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };

        // Uses user's local timezone automatically
        return new Intl.DateTimeFormat("en-US", options).format(date);
    } catch (error) {
        console.error("Date formatting error:", error);
        return "—";
    }
}


export function formatDbTime(dateString) {
    if (!dateString) return "—";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "—";

    return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}

// utils/formatDate.js
export function formatDbDateWithoutTime(dateString) {
    try {
        if (!dateString) return "—";

        const date = new Date(dateString);
        if (isNaN(date)) return "—";

        const options = {
            year: "numeric",
            month: "short",
            day: "2-digit",
        };

        // Uses user's local timezone automatically
        return new Intl.DateTimeFormat("en-US", options).format(date);
    } catch (error) {
        console.error("Date formatting error:", error);
        return "—";
    }
}

export function formatDbDateWithoutYear(dateString) {
    try {
        if (!dateString) return "—";

        const date = new Date(dateString);
        if (isNaN(date)) return "—";

        const options = {
            month: "short",
            day: "2-digit",
        };

        // Uses user's local timezone automatically
        return new Intl.DateTimeFormat("en-US", options).format(date);
    } catch (error) {
        console.error("Date formatting error:", error);
        return "—";
    }
}

